import { useState, useEffect, useCallback, useMemo } from 'react';
import { List, Stack, Typography, DialogContent, Dialog, DialogTitle, ListItemButton } from '@mui/material';
import { Country } from 'orderme-api-integration-client';
import { CountryClient } from '../../../helpers/client';
import { CountryTypography } from './registerStyles';
import { useTranslation } from 'react-i18next';

interface PhonePrefixSelectionProps {
  setSelectedCountry: (country: Country) => void;
  handleClose: () => void;
  open: boolean;
}

const defaultCountryName: string = 'Lithuania';

export function PhonePrefixSelection(props: PhonePrefixSelectionProps) {
  const { setSelectedCountry, open, handleClose } = props;
  const [countries, setCountries] = useState<Country[]>();
  const countriesClient = useMemo(() => new CountryClient(), []);
  const { t } = useTranslation();

  const getPhonePrefixes = useCallback(() => {
    countriesClient
      .get()
      .then((response) => {
        var defaultCountry = response.find((country) => country.name === defaultCountryName);

        const sortedCountries = response.sort((a, b) => a.name.localeCompare(b.name));
        setCountries(sortedCountries);
        setSelectedCountry(defaultCountry);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [countriesClient, setSelectedCountry]);

  useEffect(() => {
    getPhonePrefixes();
  }, [getPhonePrefixes]);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{t('account:choosePhonePrefix')}</DialogTitle>
      <DialogContent>
        <List>
          {countries?.map((country, index) => (
            <ListItemButton key={index} onClick={() => setSelectedCountry(country)}>
              <Stack direction="column">
                <CountryTypography>{country.name}</CountryTypography>
                <Typography>{country.phonePrefix}</Typography>
              </Stack>
            </ListItemButton>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );
}
